// Der "mehr lesen"-Button darf nur erscheinen, wenn dahinter auch wirklich
// noch Text steckt. Wo das CSS den Text abschneidet, steht in --rows (Desktop
// 7 Zeilen, Mobil 5) - erst ab MIN_HIDDEN_LINES weiteren Zeilen lohnt sich der
// Button. Vorher war die Schwelle fest auf 7 und damit identisch mit dem
// Abschneiden, sodass der Button bei ~7 Zeilen langem Text nichts aufdeckte.
const MIN_HIDDEN_LINES = 2

// --rows liest sich nur im eingeklappten Zustand richtig: aufgeklappt setzt das
// CSS --rows: 200. Klasse kurz setzen und wieder entfernen - dazwischen zeichnet
// der Browser nicht, es flackert also nichts.
function readRows(item, blockquote) {
	const wasHidden = item.classList.contains('hide')

	if (!wasHidden) item.classList.add('hide')
	const rows = parseFloat(getComputedStyle(blockquote).getPropertyValue('--rows'))
	if (!wasHidden) item.classList.remove('hide')

	return rows
}

function initItem(item) {
	const blockquote = item.querySelector('.item__content__text')
	if (!blockquote) return

	// Ungekürzt messen, sonst liefert scrollHeight nur die abgeschnittene Höhe.
	blockquote.classList.add('no-fade-out')

	const lineHeight = parseFloat(getComputedStyle(blockquote).lineHeight)
	const rows = readRows(item, blockquote)

	if (lineHeight && rows) {
		const lines = blockquote.scrollHeight / lineHeight

		if (lines > rows + MIN_HIDDEN_LINES) {
			blockquote.classList.remove('no-fade-out')
			item.classList.add('has-overflow')
			// Ein vom Besucher aufgeklapptes Item bleibt beim Neubewerten offen.
			if (!item.dataset.expanded) item.classList.add('hide')
		} else {
			item.classList.remove('hide', 'has-overflow')
		}
	}

	item.querySelectorAll('.toggle__button').forEach(button => {
		if (!button._toggleBound) {
			button.addEventListener('click', () => {
				item.classList.toggle('hide')

				if (item.classList.contains('hide')) {
					delete item.dataset.expanded
				} else {
					item.dataset.expanded = 'true'
				}
			})
			button._toggleBound = true
		}
	})
}

export function feedbackTruncate() {
	const run = () => document.querySelectorAll('.item--feedback').forEach(initItem)

	run()

	// Webfonts verschieben die Zeilenumbrüche: nach dem Laden neu bewerten,
	// sonst wird mit der Fallback-Schrift gemessen.
	if (document.fonts?.ready) {
		document.fonts.ready.then(run)
	}

	// Die Breite bestimmt die Zeilenzahl - bei Resize, Zoom und Drehen des
	// Geräts muss die Entscheidung neu fallen.
	let resizeTimer
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer)
		resizeTimer = setTimeout(run, 150)
	})

	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (!(node instanceof HTMLElement)) return
				if (node.classList.contains('item--feedback')) {
					initItem(node)
				} else {
					node.querySelectorAll('.item--feedback').forEach(initItem)
				}
			})
		})
	})

	document.querySelectorAll('.feedback').forEach(container => {
		observer.observe(container, { childList: true, subtree: true })
	})
}
